import { CachedModelLoader } from 'lib/CachedModelLoader';
import { Mutex } from 'lib/mutex';

import { BerthAssignmentDetailsResponse, BerthAssignmentDetailsResponseOptions } from 'data/models/BerthAssignmentDetailsResponse';
import { BerthReservation } from 'data/models/BerthReservation';

import { PCTabStrip, TitledTab } from 'portcall/pctabstrip/model';

import {
    BerthAssignmentDetailsActionsTab as ActionsTabModel,
    BerthAssignmentDetailsActionsTabParams as ActionsTabParams
} from './actions';
import {
    BerthAssignmentDetailsInPortOpsTab as InPortOpsTabModel,
    BerthAssignmentDetailsInPortOpsTabParams as InPortOpsTabParams
} from './inportops';

export const TabActions   : TitledTab = { Title: 'Actions'     };
export const TabInPortOps : TitledTab = { Title: 'In Port Ops' };

export interface BerthAssignmentDetailsParams {
    BerthReservation : BerthReservation;
    DismissDetails : () => void;
    /**
     * A mutex to prevent overlapping calls to save the given reservation or its child entities.
     */
    SaveMutex? : Mutex;
}

export type BerthAssignmentDetails = ReturnType<typeof BerthAssignmentDetails>;
export function BerthAssignmentDetails(
    loader : CachedModelLoader<BerthAssignmentDetailsResponse, BerthAssignmentDetailsResponseOptions>,
    actionsTabModel : (params : ActionsTabParams) => ActionsTabModel,
    inPortOpsTabModel : (params : InPortOpsTabParams) => InPortOpsTabModel,
    {
        BerthReservation,
        DismissDetails,
        SaveMutex = new Mutex()
    } : BerthAssignmentDetailsParams
) {
    const
        { model: detailsResp, loading : detailsRespLoading } = loader({ Id: BerthReservation.Id() }, 10),
        ActionsTab = actionsTabModel({
            BerthReservation,
            DismissDetails,
            PCRights: detailsResp.PCRights,
            SaveMutex
        }),
        InPortOpsTab = inPortOpsTabModel({
            BerthReservation,
            PCRights: detailsResp.PCRights,
            SaveMutex
        }),
        // The actions tab has no other content if no actions are available, so suppress the tab completely
        // in that case.
        TabStrip = PCTabStrip(TabInPortOps, () => ActionsTab.HasAnyAvailableActions() ? [TabActions] : []),
    Loading = () =>
        detailsRespLoading()
     || ActionsTab.Loading()
     || InPortOpsTab.Loading();

    return {
        DismissDetails,
        ActionsTab,
        InPortOpsTab,
        TabStrip,
        Loading
    };
}



// WEBPACK FOOTER //
// ./apps/portcall/berthassignmentdetails/model.ts